<template>
  <div class="kpi-tracker">
    <div class="table-title">營運問題KPI追蹤數值(7天) ver1</div>
    
    <div class="table-container">
      <!-- 第一级表头：位置分组 -->
      <div class="header-row level-1">
        <div class="header-cell" style="width: 33.5%">位置/平台</div>
        <div class="header-cell col-span-9" style="width: 70%">集運幫</div>
        <div class="header-cell col-span-9" style="width: 70%">樂淘</div>
        <div class="header-cell col-span-9" style="width: 70%">窩蜂</div>
      </div>
	
	    <!-- 第二级表头：平台渠道 -->
      <div class="header-row level-2">
        <div class="header-cell" style="width: 15%">指標</div>
        <div v-for="channel in channels" :key="channel.id" class="header-cell" :style="{ width: '10%' }">
          {{ channel.name }}
        </div>
        <div v-for="channel in channels" :key="'letao-' + channel.id" class="header-cell" :style="{ width: '10%' }">
          {{ channel.name }}
        </div>
        <div v-for="channel in channels" :key="'wofeng-' + channel.id" class="header-cell" :style="{ width: '10%' }">
          {{ channel.name }}
        </div>
      </div>
	
	    <!-- 表格内容 -->
      <div class="table-content">
        <!-- 位置数据 -->
        <div v-for="(location, locationIndex) in locations" :key="location.id" class="location-section">
          <!-- 指标数据行 -->
          <div v-for="(indicator, indicatorIndex) in location.indicators" :key="indicator.id" class="data-row">
            <div class="data-cell" style="width: 15%">{{location.name}}{{ indicator.name }}</div>
	
	          <!-- 集運幫数据 -->
            <div v-for="channel in channels" :key="`jyb-${location.id}-${indicator.id}-${channel.id}`" class="data-cell" style="width: 10%">
              {{ items.jyb[channel.key][location.dataKey + indicator.dataKey] }}
            </div>
	
	          <!-- 樂淘数据 -->
            <div v-for="channel in channels" :key="`letao-${location.id}-${indicator.id}-${channel.id}`" class="data-cell" style="width: 10%">
              {{ items.letao[channel.key][location.dataKey + indicator.dataKey] }}
            </div>
	
	          <!-- 窩蜂数据 -->
            <div v-for="channel in channels" :key="`wofeng-${location.id}-${indicator.id}-${channel.id}`" class="data-cell" style="width: 10%">
              {{ items.wofeng[channel.key][location.dataKey + indicator.dataKey] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	data() {
		return {
			// 平台渠道配置
			channels: [
				{ id: 1, name: '自身品牌', key: 'val' },
				{ id: 2, name: '拼多多', key: 'pdd' },
				{ id: 3, name: '菜鳥', key: 'cainiao' }
			],
			
			// 位置配置（每个位置有自己的指标列表）
			locations: [
				{
					id: 1,
					name: '珠海',
					dataKey: 'zhuhai',
					indicators: [
						{ id: 1, name: '入庫', dataKey: 'ruku' },
						{ id: 2, name: '出庫', dataKey: 'chuku' }
					]
				},
				{
					id: 2,
					name: '澳門',
					dataKey: 'aomen',
					indicators: [
						{ id: 3, name: '未上架', dataKey: 'weishangjia' },
						{ id: 4, name: '未取件', dataKey: 'weiqujian' },
						{ id: 5, name: '超期件', dataKey: 'chaoqijian' },
						{ id: 6, name: '調貨件', dataKey: 'diaohuojian' },
						{ id: 7, name: '客服件', dataKey: 'kefujian' }
					]
				}
			],
			
			// 数据
			items: {
				jyb: {
					val: {},
					pdd: {},
					cainiao: {}
				},
				letao: {
					val: {},
					pdd: {},
					cainiao: {}
				},
				wofeng: {
					val: {},
					pdd: {},
					cainiao: {}
				}
			}
		}
	},
	
	created() {
		// 初始化数据（实际项目中可能从API获取）
		this.initializeData();
	},
	
	methods: {
		initializeData() {
			// 为演示目的，生成模拟数据
			const platforms = ['jyb', 'letao', 'wofeng'];
			const channels = ['val', 'pdd', 'cainiao'];
			
			// 收集所有需要生成的指标键
			const locationKeys = [];
			this.locations.forEach(location => {
				location.indicators.forEach(indicator => {
					locationKeys.push(location.dataKey + indicator.dataKey);
				});
			});
			
			platforms.forEach(platform => {
				channels.forEach(channel => {
					locationKeys.forEach(key => {
						// 生成100-999之间的随机数
						this.$set(this.items[platform][channel], key, Math.floor(Math.random() * 900) + 100);
					});
				});
			});
		}
	}
}
</script>

<style scoped>
/* 样式保持不变 */
.kpi-tracker {
	width: 100%;
	max-width: 1400px;
	margin: 0 auto;
	padding: 20px;
	font-family: "Arial", sans-serif;
	background-color: #fff;
}

.table-title {
	text-align: center;
	font-size: 24px;
	font-weight: bold;
	margin-bottom: 20px;
	color: #333;
}

.table-container {
	border: 1px solid #ddd;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.header-row {
	display: flex;
	border-bottom: 1px solid #ddd;
}

.level-1 .header-cell {
	font-weight: bold;
	background-color: #f5f5f5;
	padding: 12px 8px;
	text-align: center;
	border-right: 1px solid #ddd;
}

.level-2 .header-cell {
	font-weight: bold;
	background-color: #f9f9f9;
	padding: 10px 8px;
	text-align: center;
	border-right: 1px solid #ddd;
	font-size: 14px;
}

.header-cell:last-child {
	border-right: none;
}

.col-span-9 {
	width: 70%; /* 9列宽度，每列约10% */
}

.table-content {
	display: flex;
	flex-direction: column;
}

.location-section {
	border-bottom: 1px solid #ddd;
}

.location-header {
	padding: 12px;
	background-color: #e9ecef;
	font-weight: bold;
	font-size: 16px;
}

.data-row {
	display: flex;
	border-bottom: 1px solid #eee;
}

.data-row:last-child {
	border-bottom: none;
}

.data-cell {
	padding: 10px 8px;
	text-align: center;
	border-right: 1px solid #eee;
	font-size: 14px;
}

.data-cell:last-child {
	border-right: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
	.header-row,
	.data-row {
		flex-wrap: wrap;
	}
	
	.header-cell,
	.data-cell {
		width: 50% !important;
		border-bottom: 1px solid #ddd;
	}
	
	.header-cell:last-child,
	.data-cell:last-child {
		border-bottom: none;
	}
	
	.location-header {
		text-align: center;
	}
	
	.level-1,
	.level-2 {
		display: none;
	}
	
	.data-cell:nth-child(odd) {
		background-color: #f9f9f9;
		font-weight: bold;
	}
}
</style>
